// REST fetchers — fetch + parse, nothing else. Base URL from env.zenoUrl.

import { env } from '../env';
import {
  parseChartPoints,
  parseEventWithMarkets,
  parsePastMarkets,
} from './parse';
import type { PricePoint, SettledEntry } from './types';

const base = () => env.zenoUrl.replace(/\/$/, '');

async function getJson(path: string): Promise<unknown> {
  const res = await fetch(`${base()}${path}`);
  if (!res.ok) {
    throw new Error(`zeno ${path}: HTTP ${res.status}`);
  }
  return res.json();
}

/** GET /events — all events with an active market */
export async function fetchBootstrap(): Promise<
  Parameters<typeof parseEventWithMarkets>[0][]
> {
  return parseBootstrap(await getJson('/events'));
}

function parseBootstrap(
  raw: unknown,
): Parameters<typeof parseEventWithMarkets>[0][] {
  return Array.isArray(raw) ? raw : [];
}

/** GET /markets/past?indicies=… — recently settled markets for the strip */
export async function fetchPastMarkets(
  marketIndexes: number[],
): Promise<SettledEntry[]> {
  if (marketIndexes.length === 0) return [];
  return parsePastMarkets(
    (await getJson(
      `/markets/past?indicies=${marketIndexes.join(',')}`,
    )) as Parameters<typeof parsePastMarkets>[0],
  );
}

/** GET /markets/past/recent?limit= — settled archive (mongo prices → history) */
export async function fetchRecentPastMarkets(
  limit: number,
): Promise<SettledEntry[]> {
  return parsePastMarkets(
    (await getJson(`/markets/past/recent?limit=${limit}`)) as Parameters<
      typeof parsePastMarkets
    >[0],
  );
}

/** GET /markets/:index/chart — sparkline hydration at bootstrap */
export async function fetchChart(marketIndex: number): Promise<PricePoint[]> {
  return parseChartPoints(
    (await getJson(`/markets/${marketIndex}/chart`)) as Parameters<
      typeof parseChartPoints
    >[0],
  );
}
